import { render, staticRenderFns } from "./positionLis.vue?vue&type=template&id=30823f4c&scoped=true&"
import script from "./positionLis.vue?vue&type=script&lang=js&"
export * from "./positionLis.vue?vue&type=script&lang=js&"
import style0 from "./positionLis.vue?vue&type=style&index=0&id=30823f4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30823f4c",
  null
  
)

export default component.exports